<template>
  <VueDragResize class="materialPicker-section" :isActive="isActive" :preventActiveBehavior="preventActiveBehavior" :w="widthComputed" :h="580" v-on:resizing="resizeCloud" v-on:dragging="resizeCloud" dragHandle=".drag">
    <!-- <div :class="rootClass"> -->
    <div class="materialPicker-topbar-wrapper drag">
      <span class="cloudIcon" style="pointer-events: none">
        <i class="fas fa-cloud"></i>
        Blitzar Cloud
      </span>
      <span class="cloudUpload"><i title="Adicionar" class="fas fa-plus" @click.prevent="materialUploadPanelHandler"></i></span>
      <span class="cloudUpload">
        <input type="file" class="file-input" id="cloudUploader" @change="uploadImage($event)" accept="image/*,video/*" />
        <label for="cloudUploader" class="upload-link"><i title="Upload" class="fas fa-upload"></i></label>
      </span>

      <!-- drag handle -->
      <i class="fas fa-grip-lines" style="pointer-events: none; margin: auto; opacity: 0.7"></i>

      <span class="cloudUpload" style="margin-left: auto" v-if="singleSelected.id"><i title="Undo" class="fas fa-undo-alt" @click.prevent="undoImageSelect"></i></span>
      <i title="Fechar" :style="{ marginLeft: singleSelected.id ? '0' : 'auto' }" class="fas fa-times-circle cloudCloseBtn" @click="$emit('close', singleSelected.links)"></i>
    </div>

    <div class="material-upload-panel-container" v-if="showMaterialUploadPanel">
      <h3 class="label-sub" style="margin: 10px 0">Adicionar material</h3>
      <div class="material-upload-panel-row">
        <label class="material-upload-label">Nome:</label>
        <input class="material-upload-panel-input" style="flex-grow: 1" type="text" v-model="uploadMaterial.name" />
        <label class="material-upload-label" style="margin-left: 10px">Tag:</label>
        <input class="material-upload-panel-input" type="text" style="max-width: 120px" v-model="uploadMaterial.tag" />
      </div>
      <div class="material-upload-panel-row">
        <label class="material-upload-label">Link:</label>
        <input class="material-upload-panel-input" type="text" v-model="uploadMaterial.links" />
      </div>
      <div class="material-upload-panel-row">
        <label class="material-upload-label">Desc:</label>
        <input class="material-upload-panel-input" type="text" v-model="uploadMaterial.description" />
      </div>
      <div class="material-upload-panel-row" style="justify-content: center; margin: 20px 0">
        <img style="width: 100%; max-height: 320px; object-fit: contain" :src="uploadMaterial.links" v-if="isParseableImage(uploadMaterial.links)" />
        <iframe :src="uploadMaterial.links" v-else frameborder="0"></iframe>
      </div>
      <div class="material-upload-panel-row">
        <button class="material-upload-panel-btn" style="margin-left: auto" @click="cancelUploadMaterial">CANCELAR</button>
        <button class="material-upload-panel-btn" @click="apiUploadMaterial">SALVAR</button>
      </div>
    </div>

    <!-- TAGS -->
    <div class="tags-container">
      <span class="tagPill tagPillActive" id="termAll" @click="tagTermAll">tudo</span>
      <span class="tagPill" :id="term" v-for="(term, key) in userTagTerms" :key="key" v-show="term" @click="tagTermHandler($event, term)">{{ term ? term : 'tudo' }}</span>
    </div>

    <!-- IMAGES -->
    <div class="images-container">
      <div v-for="(dataImage, index) in dataImagesLocal" :key="index" :class="`${rootClass}__item`">
        <div :class="classThumbnail(singleSelected.id, dataImage.id, dataImage.disabled)" @click="onSelectImage(dataImage)" v-if="!isMultiple">
          <video preload="auto" playsinline muted loop :src="dataImage.src" :id="dataImage.id" :height="h" :width="w" :class="`${rootClass}__img`" v-if="!isParseableImage(dataImage.src) && isParseableVideo(dataImage.src)"></video>
          <img :src="dataImage.src" :alt="dataImage.alt" :id="dataImage.id" :height="h" :width="w" :class="`${rootClass}__img`" v-if="isParseableImage(dataImage.src) && !isParseableVideo(dataImage.src)" />
          <div :class="`${rootClass}__img`" :src="dataImage.src" frameborder="0" v-if="!isParseableImage(dataImage.src) && !isParseableVideo(dataImage.src)">
            <iframe :src="dataImage.src" frameborder="0"></iframe>
            <i class="fas fa-link" style="margin: 6% 0 5%"></i>
            <a class="cell-item" :href="dataImage.src" target="_blank">{{ dataImage.src }}</a>
          </div>
          <label :for="dataImage.id" :class="`${rootClass}__lbl`">{{ dataImage.alt }}</label>
          <label style="color: #666" v-if="dataImage.description">- {{ dataImage.description }}</label>
          <div class="vue-select-material-btns-container">
            <div class="vue-select-material-edit-btn" @click.stop="editMaterial(dataImage)" v-if="!dataImage.isEditing">editar</div>
            <div class="vue-select-material-delete-btn" @click="apiPostDelete(dataImage)" v-if="!dataImage.isEditing"><i class="far fa-trash-alt"></i></div>
            <div class="edit-material-panel-container" v-if="dataImage.isEditing">
              <div class="edit-material-panel-row">
                <label class="edit-material-label">Nome:</label>
                <input class="edit-material-panel-input" type="text" v-model="dataImage.name" style="pointer-events: auto" />
                <label class="edit-material-label" style="margin-left: 8px; min-width: 30px">Tag:</label>
                <input class="edit-material-panel-input" type="text" v-model="dataImage.tag" style="pointer-events: auto" />
                <!-- <select class="dark-slicky-select">
                  <option value="new_tag">Criar nova tag</option>
                  <option :value="term" v-for="(term,key) in userTagTerms" :key="'term'+key" v-show="term">{{term}}</option>
                </select> -->
              </div>
              <div class="edit-material-panel-row">
                <label class="edit-material-label">URL:</label>
                <input class="edit-material-panel-input" type="text" v-model="dataImage.links" style="pointer-events: auto" />
              </div>
              <div class="edit-material-panel-row">
                <label class="edit-material-label">Desc:</label>
                <input class="edit-material-panel-input" type="text" v-model="dataImage.description" style="pointer-events: auto" />
              </div>
              <div class="edit-material-panel-row">
                <button @click="cancelPutMaterial(dataImage)" class="edit-material-panel-btn" style="margin-left: auto">CANCELAR</button>
                <button @click="apiPutMaterial(dataImage)" class="edit-material-panel-btn">SALVAR</button>
              </div>
            </div>
          </div>
        </div>
        <div :class="classThumbnailMultiple(dataImage.id, dataImage.disabled)" @click="onSelectMultipleImage(dataImage)" v-if="isMultiple">
          <img :src="dataImage.src" :alt="dataImage.alt" :id="dataImage.id" :height="h" :width="w" :class="`${rootClass}__img`" />
          <label :for="dataImage.id" v-if="useLabel" :class="`${rootClass}__lbl`">{{ dataImage.alt }}</label>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </VueDragResize>
</template>

<script>
import api from '@/services/api';
import VueDragResize from 'vue-drag-resize';

export default {
  name: 'MaterialPicker',
  components: { VueDragResize },
  props: {
    currentDataImages: {
      type: Array,
    },
    selectedImages: {
      type: Array,
      default: () => [],
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    useLabel: {
      type: Boolean,
      default: false,
    },
    rootClass: {
      type: String,
      default: 'materialPicker',
    },
    activeClass: {
      type: String,
      default: '--selected',
    },
    h: {
      type: String,
      default: 'auto',
    },
    w: {
      type: String,
      default: 'auto',
    },
    limit: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isActive: true,
      preventActiveBehavior: false,
      showMaterialUploadPanel: false,
      dataImages: [],
      currentDataImagesLocal: [],
      singleSelected: {
        id: '',
      },
      multipleSelected: [],
      width: 0,
      height: 0,
      top: 0,
      left: 0,
      uploadMaterial: {
        activity_id: null,
        name: '',
        description: null,
        links: '',
        tag: null,
        material_type: 'link',
      },
      userTagTerms: [],
      tagTerms: [null],
      isEditing: false,
    };
  },
  computed: {
    dataImagesLocal() {
      return !this.isEditing ? this.dataImages.filter((image) => this.tagTerms.includes(image.tag)) : this.dataImages.filter((image) => this.singleSelected.id == image.material_id);
    },
    widthComputed() {
      if (window.innerWidth < 768) return window.innerWidth - 6;
      else return this.width ? this.width : 720;
    },
  },
  beforeMount() {
    this.getMaterials();
  },
  mounted() {
    this.setInitialSelection();
    this.currentDataImagesLocal = this.currentDataImages;
  },
  methods: {
    tagTermAll(e) {
      // console.log('this.tagTerms', this.tagTerms);
      this.isEditing = false;
      e.target.classList.toggle('tagPillActive');
      if (e.target.classList.length == 1) {
        // console.log('tagTermAll');
        this.tagTerms = [];
      } else {
        this.tagTerms = this.userTagTerms;
        this.tagTerms.map((item) => {
          if (item) document.getElementById(item).classList.remove('tagPillActive');
        });
      }
    },
    tagTermHandler(e, term) {
      // console.log('this.tagTerms', this.tagTerms);
      this.isEditing = false;
      if (e.target.classList.contains('tagPillActive')) {
        document.getElementById('termAll').classList.add('tagPillActive');
        document.getElementById(term).classList.remove('tagPillActive');
        this.tagTerms = this.userTagTerms;
      } else {
        document.getElementById('termAll').classList.remove('tagPillActive');
        document.getElementById(term).classList.add('tagPillActive');
        this.tagTerms.map((item) => {
          if (item && item != term) document.getElementById(item).classList.remove('tagPillActive');
        });
        this.tagTerms = [term];
      }
    },
    resizeCloud(newRect) {
      this.width = newRect.width;
      this.height = newRect.height;
      this.top = newRect.top;
      this.left = newRect.left;
    },
    getMaterials() {
      api
        .get(`event/${this.$store.state.eventId}/materialList?limit=1000`)
        .then((response) => {
          this.dataImages = response.data.map((material) => {
            material.id = material.material_id;
            material.src = material.links;
            material.alt = material.name;

            return material;
          });
          this.dataImages = this.dataImages.filter((material) => {
            if (material.tag != ' ') this.userTagTerms.push(material.tag);
            return material.activity_id == null && !material.name.endsWith('.csv') && !material.name.endsWith('xlsx') && !material.src.endsWith('-blob');
          });
          let uniqueTagTerms = new Set(this.userTagTerms);
          this.userTagTerms = Array.from(uniqueTagTerms);
          this.tagTerms = Array.from(uniqueTagTerms);
          // console.log('MATERIAL LIST RESPONSE: ', response);
        })
        .catch((err) => console.error(err));
    },
    editMaterial(dataImage) {
      this.onSelectImage(dataImage);
      this.isEditing = true;
      this.isActive = !this.isActive;
      this.preventActiveBehavior = !this.preventActiveBehavior;
      this.dataImages.map((item) => {
        if (item.material_id == dataImage.material_id) {
          item.isEditing = true;
          // console.log('editMaterial', { dataImage });
        } else item.isEditing = false;
      });
      // this.tagTerms = [dataImage.tag];
      // this.dataImages = this.dataImages.filter((item) => item.material_id == dataImage.material_id);
    },
    deleteMaterial(dataImage) {
      this.$modal.show('dialog', {
        title: 'ATENÇÂO! Ação não recuperável',
        text: 'Deseja excluir material?',
        buttons: [
          {
            title: 'Sim',
            handler: () => {
              api
                .delete(`event/${this.$store.state.eventId}/materialList/${dataImage.material_id}`)
                .then((response) => {
                  this.getMaterials();
                  //console.log('MATERIAL LIST DELETE: ', response);
                  this.$modal.hide('dialog');
                })
                .catch((err) => console.error(err));
            },
          },
          {
            title: 'Não',
            handler: () => {
              this.$modal.hide('dialog');
            },
          },
        ],
      });
    },

    apiPostDelete(dataImage) {
      this.$modal.show('dialog', {
        title: 'ATENÇÂO! Ação não recuperável',
        text: 'Deseja excluir material?',
        buttons: [
          {
            title: 'Sim',
            handler: async () => {
              await api.post(`event/${this.$store.state.eventId}/materialDeleteList`, {
                list_id: [dataImage.material_id],
              });
              this.dataImages = this.dataImages.filter((item) => item.material_id != dataImage.material_id);

              this.$modal.hide('dialog');
            },
          },
          {
            title: 'Não',
            handler: () => {
              this.$modal.hide('dialog');
            },
          },
        ],
      });
    },

    cancelPutMaterial(dataImage) {
      this.isEditing = false;
      this.isActive = !this.isActive;
      this.preventActiveBehavior = !this.preventActiveBehavior;
      dataImage.isEditing = false;
    },
    apiPutMaterial(dataImage) {
      let payload = {
        material_id: dataImage.material_id,
        name: dataImage.name,
        description: dataImage.description,
        tag: dataImage.tag ? dataImage.tag : ' ',
        links: dataImage.links,
      };

      payload.size = JSON.stringify(payload.size);
      api
        .put(`event/${this.$store.state.eventId}/materialList/${payload.material_id}`, payload)
        .then((response) => {
          // console.log('MATERIAL LIST PUT RESPONSE: ', response);
          this.isEditing = false;
          this.isActive = !this.isActive;
          this.preventActiveBehavior = !this.preventActiveBehavior;
          dataImage.isEditing = false;
          this.userTagTerms = [];
          this.getMaterials();
          document.getElementById('termAll').classList.add('tagPillActive');
        })
        .catch((err) => console.error(err));
    },
    apiUploadMaterial() {
      api
        .post(`event/${this.$store.state.eventId}/materialList/`, this.uploadMaterial)
        .then((response) => {
          // console.log('MATERIAL LIST UPLOAD RESPONSE: ', response);
          this.showMaterialUploadPanel = false;
          // this.isActive = !this.isActive;
          // this.preventActiveBehavior = !this.preventActiveBehavior;
          this.getMaterials();
        })
        .catch((err) => console.error(err));
    },
    cancelUploadMaterial() {
      this.isActive = true;
      this.preventActiveBehavior = false;
      this.showMaterialUploadPanel = false;
    },
    materialUploadPanelHandler() {
      this.isActive = !this.isActive;
      this.preventActiveBehavior = !this.preventActiveBehavior;
      this.showMaterialUploadPanel = !this.showMaterialUploadPanel;
    },
    classThumbnail(selectedId, imageId, isDisabled) {
      const baseClass = `${this.rootClass}__thumbnail`;
      if (isDisabled) {
        return `${baseClass} ${baseClass}--disabled`;
      }
      if (selectedId === imageId) {
        return `${baseClass} ${baseClass}${this.activeClass}`;
      }
      return `${baseClass}`;
    },
    classThumbnailMultiple(id, isDisabled) {
      const baseClass = `${this.rootClass}__thumbnail`;
      const baseMultipleClass = `${baseClass} is--multiple`;
      if (isDisabled) {
        return `${baseMultipleClass} ${baseClass}--disabled`;
      }
      if (this.isExistInArray(id)) {
        return `${baseMultipleClass} ${baseClass}${this.activeClass}`;
      }
      return `${baseMultipleClass}`;
    },
    onSelectImage(objectImage) {
      if (!objectImage.disabled) {
        this.singleSelected = Object.assign({}, this.singleSelected, objectImage);
        this.$emit('onSelectImage', this.singleSelected);
        // console.log('onSelectImage onSelectImage src:', this.currentDataImagesLocal[0]);
      }
    },
    undoImageSelect() {
      this.$emit('onSelectImage', { src: this.currentDataImagesLocal[0] });
      this.singleSelected = {};
      // console.log('undoImageSelect onSelectImage src:', this.currentDataImagesLocal[0]);
    },
    isExistInArray(id) {
      return this.multipleSelected.find((item) => {
        return id === item.id;
      });
    },
    removeFromSingleSelected() {
      this.singleSelected = {};
      this.$emit('onSelectImage', {});
    },
    removeFromMultipleSelected(id, dontFireEmit) {
      this.multipleSelected = this.multipleSelected.filter((item) => {
        return id !== item.id;
      });
      if (!dontFireEmit) {
        this.$emit('onselectmultipleimage', this.multipleSelected);
      }
    },
    resetMultipleSelection() {
      this.multipleSelected = [];
    },
    onSelectMultipleImage(objectImage) {
      if (!objectImage.disabled) {
        if (!this.isExistInArray(objectImage.id)) {
          if (this.limit > 0) {
            if (this.multipleSelected.length < this.limit) {
              this.multipleSelected.push(objectImage);
              this.$emit('onselectmultipleimage', this.multipleSelected);
            } else {
              this.$emit('onreachlimit', this.limit);
            }
          } else {
            this.multipleSelected.push(objectImage);
            this.$emit('onselectmultipleimage', this.multipleSelected);
          }
        } else {
          this.removeFromMultipleSelected(objectImage.id, true);
          this.$emit('onselectmultipleimage', this.multipleSelected);
        }
      }
    },
    setInitialSelection() {
      if (this.selectedImages) {
        if (!this.isMultiple && this.selectedImages.length === 1) {
          this.singleSelected = Object.assign({}, this.selectedImages[0]);
        } else {
          this.multipleSelected = [].concat(this.selectedImages);
        }
      }
    },
    uploadImage(e) {
      // console.log('uploadImage', e.target.files[0]);
      let formData = new FormData();
      formData.append('file', e.target.files[0]);

      api
        .post(`event/${this.$store.state.eventId}/materialUpload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          // console.log('file upload', response);
          this.getMaterials();
        })
        .catch((err) => console.error(err));
    },
    isParseableVideo(src) {
      return src.toLowerCase().endsWith('.webm') || src.toLowerCase().endsWith('.mp4');
    },
    isParseableImage(src) {
      return (
        src.toLowerCase().startsWith('data:image/') ||
        src.toLowerCase().endsWith('.gif') ||
        src.toLowerCase().endsWith('.jpg') ||
        src.toLowerCase().endsWith('.jpeg') ||
        src.toLowerCase().endsWith('.png') ||
        src.toLowerCase().endsWith('.svg') ||
        src.toLowerCase().endsWith('.webp') ||
        src.toLowerCase().endsWith('.apng') ||
        src.toLowerCase().endsWith('.avif') ||
        src.toLowerCase().endsWith('.jfif') ||
        src.toLowerCase().endsWith('.pjpeg') ||
        src.toLowerCase().endsWith('.pjp') ||
        src.toLowerCase().startsWith('https://store-images')
      );
    },
  },
};
</script>

<style lang="scss">
.materialPicker-section {
  // position: relative;
  margin: 0;
  padding: 0 0 80px 0;
  max-height: 90vh;
  overflow: hidden;
  list-style-image: none;
  list-style-position: outside;
  list-style-type: none;
  background: #222;
  border: 3px solid #e60ed0;
  border-top: none;
  border-radius: 10px;
  z-index: 10 !important;

  display: flex;
  flex-direction: column;

  .materialPicker-topbar-wrapper {
    cursor: grab;
    position: relative;
    width: 100%;
    height: 48px;
    padding: 0;
    color: #eee;
    background: #e60ed0;

    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;

    .cloudIcon {
      position: relative;
      font-family: 'SegoeUI';
      padding: 10px;
      color: #eee;
      text-align: left;
      margin-right: 10px;
    }
    .file-input {
      // position: absolute;
      width: 0px;
      height: 0px;
      opacity: 0;
    }
    .cloudUpload {
      cursor: pointer;
      position: relative;
      font-size: 1.1rem;
    }
    .cloudCloseBtn {
      cursor: pointer;
      position: relative;
      margin: 0 10px 0 auto;
      font-size: 1.6rem;
      color: #eeeeeeee;
    }
  }
  .tags-container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    // justify-content: center;
    padding: 10px;
    background: #3338;
  }
  .tagPill {
    cursor: pointer;
    position: relative;
    font-size: 0.78rem;
    background: transparent;
    border-radius: 1000px;
    color: #bbb;
    padding: 4px 8px 6px;
    margin: 4px;
    border: 1px solid #eeeeee90;
  }
  .tagPillActive {
    background: #eeeeeedd;
    color: #e60ed0;
  }
  .material-upload-panel-container {
    position: absolute;
    inset: 48px 0 0 0;
    z-index: 1;
    min-height: 620px;
    padding: 16px;
    background: #555;

    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .images-container {
    position: relative;
    height: 100%;
    overflow-y: auto;
    padding: 0 4px 10px 4px;
    color: #777;
  }
  .materialPicker__item {
    margin: 10px;
    float: left;
  }
  .materialPicker__thumbnail {
    cursor: pointer;
    padding: 6px;
    display: block;
    padding: 4px;
    line-height: 20px;
    border: 1px solid #eeeeee40;

    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;

    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.055);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.055);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.055);

    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
  }
  .materialPicker__thumbnail--selected {
    background: #333;
    border: 1px solid #999;
    box-shadow: 0px 0px 4px #ffffff99;
  }
  .materialPicker__thumbnail--disabled {
    background: #b9b9b9;
    cursor: not-allowed;
  }
  .materialPicker__thumbnail--disabled > .materialPicker__img {
    opacity: 0.5;
  }
  .materialPicker__img {
    -webkit-user-drag: none;
    display: block;
    max-width: 220px;
    max-height: 140px;
    margin-right: auto;
    margin-left: auto;
    color: #bbb;
    margin: 0 10px;

    display: flex;
    flex-direction: column;

    iframe {
      height: auto;
      aspect-ratio: 16/9;
    }

    a {
      color: #eee;
      background: #30303090;
      word-break: break-all;
      max-height: 20%;
      overflow-y: hidden;
    }
    i {
      font-size: 0.6rem;
    }
  }
  .materialPicker__lbl {
    line-height: 2.9;
    color: #999;
    font-size: 0.92rem;
    // background: red;
    margin-left: 8px;
  }
  .vue-select-material-btns-container {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .vue-select-material-edit-btn {
    padding: 4px 8px;
    margin: 2px 20px 2px 2px;
    background: #55555513;
    color: #ffffff40;
    font-size: 0.8rem;
    border-radius: 4px;
    border: none;
  }
  .edit-material-panel-container {
    position: relative;
    z-index: 1;
    margin: 0 -4px -4px;
    padding: 2%;
    background: #444;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .edit-material-panel-row,
  .material-upload-panel-row {
    position: relative;
    display: flex;
    align-items: center;
    flex-grow: 1;
    width: 100%;
    margin: 8px 0;
  }
  .edit-material-label,
  .material-upload-label {
    position: relative;
    color: #bbb;
    margin: 0 10px 0 0px;
    min-width: 54px;
    text-align: left;
  }
  .edit-material-panel-input,
  .material-upload-panel-input {
    position: relative;
    width: 100%;
    background: #333;
    padding: 8px;
    border-radius: 6px;
    border: none;
    color: #eee;
    font-size: 1rem;
  }
  .edit-material-panel-btn,
  .material-upload-panel-btn {
    cursor: pointer;
    padding: 8px 12px;
    margin: 2px 20px 2px 2px;
    background: #666;
    color: #eee;
    font-size: 0.8rem;
    border-radius: 4px;
    border: none;
    &:hover {
      background: #eee;
      color: #666;
    }
  }
  .vue-select-material-delete-btn {
    margin-right: 6px;
    border-radius: 4px;
    color: #808080;
    z-index: 0;
  }
  // .vdr.active:before {
  //   outline: none !important;
  // }
  // .vdr-stick {
  //   border: none !important;
  //   box-shadow: none !important;
  //   z-index: 10000 !important;
  //   background: transparent !important;
  // }

  // .vdr-stick-ml,
  // .vdr-stick-mr {
  //   margin: 0 0 0 0 !important;
  //   transform: translateY(-50%);
  //   height: 145% !important;
  // }

  // .vdr-stick-tl,
  // .vdr-stick-bl,
  // .vdr-stick-tr,
  // .vdr-stick-br {
  //   width: 14px !important;
  //   height: 14px !important;
  // }

  // .vdr-stick-tm,
  // .vdr-stick-bm {
  //   margin: 0 0 0 -48% !important;
  //   width: 96% !important;
  // }

  ::-webkit-scrollbar {
    background-color: transparent;
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #777;
    border-radius: 4px;
  }
}
</style>
